import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { isAuthenticated, logoutUser } from '../services/api';
import { getUserSessionExpiry, clearUserSession, getSessionRole } from '../services/session';

const SessionManager = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const forceLogout = useCallback(() => {
    const role = getSessionRole();
    clearUserSession();
    localStorage.removeItem('adminProfile');
    logoutUser();
    toast.info('Session expired. Please login again.', {
      position: 'top-right',
      autoClose: 3000,
    });
    const redirect = role === 'admin' ? '/login?redirect=/admin' : '/login';
    navigate(redirect, { replace: true });
  }, [navigate]);

  const scheduleLogout = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);

    if (!isAuthenticated()) return;

    const expiry = getUserSessionExpiry();
    if (!expiry || Date.now() >= expiry) {
      forceLogout();
      return;
    }

    timerRef.current = setTimeout(() => {
      if (isAuthenticated()) {
        forceLogout();
      }
    }, expiry - Date.now());
  }, [forceLogout]);

  useEffect(() => {
    scheduleLogout();
    const intervalId = setInterval(scheduleLogout, 30 * 1000);
    window.addEventListener('logout', scheduleLogout);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timerRef.current);
      window.removeEventListener('logout', scheduleLogout);
    };
  }, [location.pathname, scheduleLogout]);

  return null;
};

export default SessionManager;